<template lang="pug">
#side-nav
  .nav-item
    .label 
      i.el-icon-upload2.margin-right
      | Share Photo
</template>

<script>
export default {
  name: "SideNav",
  methods: {
    randomCount() {
      return parseInt(Math.random(10) * 100);
    }
  }
};
</script>

<style lang="stylus">
#side-nav {
  border-radius();
  border: $color-light-border 1px solid;
  margin: 20px 0;
  margin-right: 20px;

  .nav-item {
    animate();
    font-size: 0.9em;
    font-weight: bold;
    line-height: 50px;
    position: relative;
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap;
    width: 100%;

    &:not(:last-child) {
      border-bottom: $color-light-border 1px solid;
    }

    .label {
      padding: 0 20px;
    }

    .count {
      pinned(absolute);
      border-radius(4px);
      background-color: $color-info;
      color: white;
      left: auto;
      right: 10px;
      top: 15px;
      bottom: auto;
      font-size: 0.8em;
      padding: 0 8px;
      line-height: 20px;
    }

    &:hover {
      background-color: $color-lightest-grey;
      color: black;
      cursor: pointer;
    }
  }
}
</style>
